export const WORK_SPACE_RESET = "WORK_SPACE_RESET" as const;
export const WORK_SPACE_GET_ALL = "WORK_SPACE_GET_ALL" as const;
